
import { Options, Vue } from "vue-class-component";
import store from "@/store/index";
import {
  GOOGLE_AUTH_CALLBACK_URL,
  MICROSOFT_AUTH_CALLBACK_URL
} from "@/utils/esternal_service";
import {
  ADMIN_SCHOOL_AI_USAGE_EXPIRED_MESSAGE,
  adminSignInWithExternalProvider,
  isAdminSchoolAiUsageExpiredError
} from "@/api/auth";
import { consumePostLoginRedirect } from "@/utils/post_login_redirect";

@Options({
  props: {
    type: String
  }
})
export default class AuthRedirect extends Vue {
  type: "google" | "microsoft" | "" = "";

  clearUrl() {
    window.history.pushState(
      {},
      "",
      window.location.origin + window.location.pathname
    );
  }

  async created(): Promise<void> {
    const searchParams = new URLSearchParams(window.location.search);
    const code: string | null = searchParams.get("code");
    const error: string | null = searchParams.get("error");
    const state: string | null = searchParams.get("state"); // "tutor" or "student"

    if (error) {
      this.clearUrl();
      alert("ログインに失敗しました。");
      this.$router.push("/login");
      return;
    }

    if (!code) return;
    if (!this.type) return;
    if (this.type !== "google" && this.type !== "microsoft") return;
    if (!state) return;
    if (state !== "tutor" && state !== "student") return;

    this.clearUrl();

    try {
      store.commit("START_LOADING", "ログイン中...");

      if (state !== "tutor") {
        throw new Error("Invalid state");
      }

      await adminSignInWithExternalProvider(
        this.type,
        code,
        this.type === "google"
          ? GOOGLE_AUTH_CALLBACK_URL
          : MICROSOFT_AUTH_CALLBACK_URL
      );

      store.commit("END_LOADING");
      this.$router.push(consumePostLoginRedirect());
    } catch (e) {
      alert(
        isAdminSchoolAiUsageExpiredError(e)
          ? ADMIN_SCHOOL_AI_USAGE_EXPIRED_MESSAGE
          : "ログインに失敗しました。" +
              (e instanceof Error ? e.message : "unknown error")
      );
      store.commit("END_LOADING");
      this.$router.push("/login");
    } finally {
      store.commit("END_LOADING");
    }
  }
}
